import { useState } from "react";
import { Payload, Platform } from "@/types/profile";
import { PayloadGrid } from "./PayloadGrid";
import { PayloadConfigPreview } from "./PayloadConfigPreview";
import { getPayloadById } from "@/utils/payloads";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable";

interface PayloadTwoPanelSelectorProps {
  selectedPlatforms: Platform[];
  selectedPayloads: string[];
  onSelectPayload: (payloadId: string) => void;
  onConfigurePayload?: (payloadId: string) => void;
}

export const PayloadTwoPanelSelector = ({
  selectedPlatforms,
  selectedPayloads,
  onSelectPayload,
  onConfigurePayload,
}: PayloadTwoPanelSelectorProps) => {
  const [selectedPayloadForPreview, setSelectedPayloadForPreview] = useState<Payload | null>(null);

  const handlePayloadSelect = (payload: Payload) => {
    setSelectedPayloadForPreview(payload);
  };

  return (
    <div className="h-[600px] border rounded-lg overflow-hidden">
      <ResizablePanelGroup direction="horizontal" className="h-full">
        {/* Left Panel - Payload Discovery */}
        <ResizablePanel defaultSize={50} minSize={30}>
          <div className="h-full border-r">
            <div className="p-4 border-b bg-muted/50">
              <h3 className="font-semibold text-sm">Available Payloads</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Browse and filter payloads to add to your profile
              </p>
            </div>
            <PayloadGrid
              selectedPlatforms={selectedPlatforms}
              selectedPayloads={selectedPayloads}
              onSelectPayload={onSelectPayload}
              onPayloadSelect={handlePayloadSelect}
            />
          </div>
        </ResizablePanel>

        <ResizableHandle />

        {/* Right Panel - Payload Details */}
        <ResizablePanel defaultSize={50} minSize={30}>
          <div className="h-full">
            <div className="p-4 border-b bg-muted/50">
              <h3 className="font-semibold text-sm">Payload Details</h3>
              <p className="text-xs text-muted-foreground mt-1">
                View configuration options and compatibility
              </p>
            </div>
            <PayloadConfigPreview
              payload={selectedPayloadForPreview}
              selectedPlatforms={selectedPlatforms}
              isSelected={selectedPayloadForPreview ? selectedPayloads.includes(selectedPayloadForPreview.id) : false}
              onSelect={onSelectPayload}
              onConfigure={onConfigurePayload}
            />
          </div>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
};